import { Prod } from '@interfaces/Prod'; 
import { Mock } from '@interfaces/Mock'; 

export const DataSource = (ENV) => {
  switch (ENV) {
    case 'MOCK':
      return new Mock();
    case 'PROD':
      return new Prod();
    default:
      return new Mock();
  }
};




